import { Box } from '@hivebrite/design-system/Box';
import { CheckboxInput } from '@hivebrite/design-system/Inputs';

interface OnlineCheckboxProps {
  disabled: boolean;
  id: string;
  inputName: string;
  isOnlineChecked: boolean;
  onlineLabel: string;
  updateOnline: (isOnlineChecked: boolean) => void;
}

export const OnlineCheckbox = ({
  isOnlineChecked,
  disabled,
  id,
  onlineLabel,
  inputName,
  updateOnline,
}: OnlineCheckboxProps) => (
  <Box
    display="flex"
    alignItems="center"
    ml={{ s: 0, m: 3 }}
    mt={{ s: 2, m: 1 }}
  >
    <CheckboxInput
      checked={isOnlineChecked}
      disabled={disabled}
      id={`${id}-online`}
      label={onlineLabel}
      name={`${inputName}[online]`}
      onChange={(e) => {
        updateOnline(e.target.checked);
      }}
      variant="normal"
    />
  </Box>
);
